import { useNavigate } from 'react-router-dom'
import { useTheme } from '../../contexts/ThemeContext'

const FREE_FEATURES = [
  'registro de gastos e ingresos',
  '1 meta activa',
  'resumen mensual',
  'planificador de viajes',
  'temas visuales básicos',
]

const PREMIUM_FEATURES = [
  'metas ilimitadas',
  'insights financieros avanzados',
  'resumen semanal inteligente',
  'temas exclusivos',
  'reportes PDF mensuales',
  'modo pareja (próximamente)',
  'coach financiera con IA (próximamente)',
]

export default function Premium() {
  const navigate = useNavigate()
  const { theme } = useTheme()
  const s = makeStyles(theme)

  return (
    <div style={s.container}>
      <button style={s.backBtn} onClick={() => navigate(-1)}>← volver</button>

      <div style={s.hero}>
        <p style={s.sparkle}>✦</p>
        <h1 style={s.heroTitle}>Florece<br />Premium</h1>
        <p style={s.heroSub}>tu dinero, tu alma, sin límites</p>
      </div>

      <div style={s.plans}>
        {/* Plan Gratis */}
        <div style={s.planCard}>
          <p style={s.planName}>Gratis</p>
          <p style={s.planPrice}>$0<span style={s.planPer}>/siempre</span></p>
          <div style={s.featureList}>
            {FREE_FEATURES.map(f => (
              <div key={f} style={s.featureItem}>
                <span style={s.checkNeutral}>○</span>
                <span style={s.featureText}>{f}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Plan Premium */}
        <div style={{ ...s.planCard, ...s.planPremium }}>
          <div style={s.premiumBadge}>✦ premium</div>
          <p style={{ ...s.planName, color: 'white' }}>Premium</p>
          <p style={{ ...s.planPrice, color: 'white' }}>
            próximamente<span style={{ ...s.planPer, color: 'rgba(255,255,255,0.6)' }}></span>
          </p>
          <div style={s.featureList}>
            {PREMIUM_FEATURES.map(f => (
              <div key={f} style={s.featureItem}>
                <span style={s.checkPremium}>✦</span>
                <span style={{ ...s.featureText, color: 'rgba(255,255,255,0.85)' }}>{f}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <button style={s.ctaBtn}>
        súmate a la lista de espera ✦
      </button>

      <p style={s.closing}>
        Florece es un proyecto con alma — gracias por estar aquí.
      </p>
    </div>
  )
}

const makeStyles = (t) => ({
  container: {
    maxWidth: 560, margin: '0 auto',
    padding: '32px 28px 80px',
    fontFamily: "'DM Sans', sans-serif",
    background: t.cream, minHeight: '100vh',
  },
  backBtn: {
    background: 'none', border: 'none', cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: t.inkLight,
    padding: '0 0 24px', display: 'block',
  },
  hero: { textAlign: 'center', marginBottom: 36 },
  sparkle: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 36, color: t.gold, margin: '0 0 8px',
  },
  heroTitle: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: 52, fontWeight: 300, color: t.ink,
    lineHeight: 1.1, margin: '0 0 12px',
  },
  heroSub: {
    fontFamily: "'Lora', serif", fontStyle: 'italic', fontSize: 19,
    color: t.inkLight,
  },
  plans: { display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 28 },
  planCard: {
    background: t.paper, borderRadius: 22,
    border: `1.5px solid ${t.cardBorder}`,
    padding: '24px',
  },
  planPremium: {
    background: t.cardGradient, border: 'none',
    boxShadow: `0 16px 40px ${t.accentDeep}44`,
    position: 'relative', overflow: 'hidden',
  },
  premiumBadge: {
    position: 'absolute', top: 16, right: 16,
    background: 'rgba(255,255,255,0.2)', borderRadius: 20,
    padding: '4px 12px', fontSize: 11, color: 'white',
    letterSpacing: 1.5, textTransform: 'uppercase', fontWeight: 500,
  },
  planName: {
    fontFamily: "'Cormorant Garamond', serif", fontSize: 13,
    letterSpacing: 2, textTransform: 'uppercase', color: t.inkLight,
    margin: '0 0 6px',
  },
  planPrice: {
    fontFamily: "'Cormorant Garamond', serif", fontSize: 34, fontWeight: 600,
    color: t.ink, margin: '0 0 20px',
  },
  planPer: {
    fontFamily: "'DM Sans', sans-serif", fontSize: 14,
    color: t.inkLight, fontWeight: 400,
  },
  featureList: { display: 'flex', flexDirection: 'column', gap: 10 },
  featureItem: { display: 'flex', alignItems: 'center', gap: 10 },
  checkNeutral: { color: t.inkLight, fontSize: 12, flexShrink: 0 },
  checkPremium: { color: 'rgba(255,255,255,0.8)', fontSize: 12, flexShrink: 0 },
  featureText: { fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: t.inkMid },
  ctaBtn: {
    width: '100%', padding: '18px', borderRadius: 20, border: 'none',
    background: t.cardGradient, color: 'white',
    fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontStyle: 'italic',
    cursor: 'pointer', marginBottom: 24,
    boxShadow: `0 10px 30px ${t.accentDeep}44`,
  },
  closing: {
    fontFamily: "'Lora', serif", fontStyle: 'italic', fontSize: 16,
    color: t.inkLight, textAlign: 'center', lineHeight: 1.5,
  },
})
